module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-ngampilan.dcb44b01.png";